module.exports = __webpack_public_path__ + "img/user.154d8fed.svg";